import { BlogPostSnippetProps } from './BlogPostSnippet.types';
import React from 'react';
import { NameBanner } from '../../../../Rumblefish23Theme';
import {
  AuthorsStack,
  SingleAuthorStack,
  AvatarImage,
  StyledAuthorName,
  StyledContent,
  StyledImage,
  StyledMainStack,
  StyledDesktopTechnologiesStack,
  StyledTitle,
} from './styles';
import { ScrollContainer } from 'react-indiana-drag-scroll';
import 'react-indiana-drag-scroll/dist/style.css';
import { useTheme } from '@mui/material';
import { getPlainText } from '../utils/getPlainText';
import {
  ComponentTagsListTag,
  Maybe,
} from '@rumblefish/strapi/src/strapiTypes';

const BlogPostTechnologies = ({
  technologies,
}: {
  technologies: Maybe<ComponentTagsListTag>[];
}) => (
  <>
    {technologies.map((technology, index) => {
      return (
        technology && (
          <NameBanner
            type="element"
            key={index}
            text={technology?.name || ''}
          />
        )
      );
    })}
  </>
);

const BlogPostTechnologiesWrapper = ({
  isMobile,
  technologies,
}: {
  isMobile: boolean;
  technologies: Maybe<ComponentTagsListTag>[];
}) => {
  return isMobile ? (
    <ScrollContainer
      style={{
        width: '100%',
        flexDirection: 'row',
        display: 'flex',
        flexWrap: 'nowrap',
        gap: '8px',
      }}>
      <BlogPostTechnologies technologies={technologies} />
    </ScrollContainer>
  ) : (
    <StyledDesktopTechnologiesStack>
      <BlogPostTechnologies technologies={technologies} />
    </StyledDesktopTechnologiesStack>
  );
};

export const BlogPostSnippet = ({
  mainImageSrc,
  authors,
  title,
  textContent,
  technologies,
  ...props
}: BlogPostSnippetProps): React.ReactElement => {
  const isMobile = useTheme().utils.isMobile();

  return (
    <StyledMainStack {...props}>
      <StyledImage alt={`${title}_BlogPostImage`} src={mainImageSrc} />
      <StyledTitle variant="strong_600">{title}</StyledTitle>
      <AuthorsStack>
        {authors.map(
          (author, index) =>
            author && (
              <SingleAuthorStack key={author.documentId || index}>
                <AvatarImage
                  alt={`${author?.Avatar?.name}_BlogPostAuthorAvatar`}
                  src={author?.Avatar?.url || ''}
                />
                <StyledAuthorName variant="strong_200">
                  {`By ${author?.Name}`}
                </StyledAuthorName>
              </SingleAuthorStack>
            )
        )}
      </AuthorsStack>
      <StyledContent variant="regular_300">
        {getPlainText(textContent)}
      </StyledContent>
      {technologies && technologies.length > 0 && (
        <BlogPostTechnologiesWrapper
          isMobile={isMobile}
          technologies={technologies}
        />
      )}
    </StyledMainStack>
  );
};
